import ConviteDiagnosticoForm from "@/modules/convite-diagnostico/components/convite-diagnostico-form";
const ConviteDiagnosticoPage = () => {
  return <ConviteDiagnosticoForm />;
};
export default ConviteDiagnosticoPage;
